import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    padding: 1.8rem;
    width: 45rem;
    max-height: 85vh;
    overflow-y: auto;
    font-family: 'Inter', sans-serif;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 1rem;
`

export const HeaderText = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover {
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const InputDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
`

export const LabelCreate = styled.label`
    font-weight: 600;
    font-size: 0.9rem;
`

export const InputField = styled.input`
    width: 100%;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;

    :focus {
        outline: 0;
        background-color: #E0E0E0;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
        color: #555;
    }
`

export const SelectField = styled.select`
    width: 100%;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;
    cursor: pointer;

    :focus {
        outline: 0;
        background-color: #E0E0E0;
    }
`

export const ModalActionsColumn = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 1rem;
    margin-top: 1.5rem;
    width: 100%;
`

export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    justify-content: end;
    align-items: center;
    margin-top: 1.5rem;
`

/** Mesmo que ButtonsDiv, sem margin-top (uso dentro de ModalActionsColumn) */
export const ButtonsDivFlush = styled(ButtonsDiv)`
    margin-top: 0;
`

export const CreateButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 5.8vh;
    padding: 1.5rem;
    background-color: #0090D3;
    color: #fff;
    border-radius: 3vw;
    cursor: pointer;

    :hover {
        background-color: #007AB8;
    }
`

export const CreateButtonImage = styled.img`
    width: 1vw;
`

export const CreateButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.5rem;
    margin-right: 0.2rem;
`

export const DangerButtonDiv = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5.8vh;
    padding: 1rem 1.5rem;
    background-color: #F87171;
    color: #fff;
    border: none;
    border-radius: 3vw;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.85rem, 1vw, 1rem);
    font-weight: 700;

    :hover {
        background-color: #E56B6B;
    }
`

export const ErrorMessage = styled.p`
    font-size: 0.85rem;
    color: red;
    font-weight: 400;
    background-color: #FFE6E6;
    padding: 0.8rem;
    border-radius: 0.5rem;
    margin-top: 1rem;
`

export const TipText = styled.p`
    font-family: 'Inter', sans-serif;
    color: red;
    font-weight: 300;
    font-size: 0.8rem;
    margin-right: 1rem;
    margin-top: 0;
`

export const SkillChipsWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
`

export const SkillChip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 12px;
    background: #e8f0fe;
    color: #1a56db;
    font-size: 13px;
    font-weight: 500;
`

export const SkillChipRemoveButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0 2px;
    color: #1a56db;
    font-weight: 700;
    line-height: 1;
`
